export const HeaderTestIds = {
  SIDEBAR_TOGGLE: 'header.sidebar-toggle-button',
};
